/**
 * 不知怎么归类
 */
import $http from '@/resource';
import utils from '@/utils';
import Cache from '@/cache';

const $api = {};

/**
 * 获取单位分组列表
 *
 * @param {array} searchData 搜索条件数组
 *
 * @returns {Promise<any>}
 */
$api.getCompanyList = (searchData)=>{
    const url = "companys";
    const promise = new Promise(resolve=>{
        $http.get(url, {params: searchData}).then(response=>{
            if (response.code === "200") {
                resolve(response);
            } else {
                utils.notice(response.msg, 'error');
            }
        });
    });
    return promise;
};

export default $api;


// WEBPACK FOOTER //
// ./src/service/company/extra.js